module.exports = __webpack_public_path__ + "img/bg_all.a595b931.png";